/**
 * Public (marketing) routes. Trackers only load here (see public/index.html)
 * and the SiteMotion layer only animates here. Keep in sync with index.html.
 */
export const PUBLIC_TRACKED_PAGES = new Set([
  '/', '/login', '/register', '/accept-terms',
  '/how-it-works', '/concierge', '/privacy-concierge', '/about', '/wellness', '/ecosystem', '/care',
  '/help', '/safety-tips', '/contact', '/faq', '/blogs',
  '/methodology', '/intentional-matchmaking', '/relationship-intelligence', '/couple', '/couple/begin', '/quiz', '/alliance-members', '/alliance-members/terms',
  '/privacy', '/terms', '/cancellation-policy', '/about-legal',
  '/book', '/book/sample',
  '/v2/me', '/v2/couple', '/v2/couple/preview', '/portrait', '/v2/individual', '/v2/single',
  '/subscription/success',
]);
